export default __webpack_public_path__ + "static/char-v-05-2d9d661009c189f5f71c70d0406b6887.webp";